import React, { useEffect, useState } from "react";
import { FaDownload } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  getMediaName,
  getOrderDetail,
  getOrderMedia,
  updateSyncData,
  updateSyncDataOrikomi,
} from "../../../features/order/orderSlice";
import { setToken } from "../../../features/auth/authSlice";
// Modal
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";

const DistributionInformation = ({ dataDetail, token }) => {
  const [fileName, setFileName] = useState("");

  Modal.setAppElement("#root");
  // Redux
  const dispatch = useDispatch();
  const orderId = dataDetail?.order_key;

  const getOrderDetailData = () => {
    const data = {
      order_key: orderId,
    };
    dispatch(getOrderDetail({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === "success" && newToken) {
          dispatch(setToken(newToken));
        }
      })
      .catch((error) => {});
  };
  const getOrderMediaName = () => {
    const data = {
      order_key: orderId,
      system_name: process.env.REACT_APP_SYSTEM_NAME,
    };
    dispatch(getMediaName({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === "success" && newToken) {
          setFileName(res.data.value);
          dispatch(setToken(newToken));
        }
      })
      .catch((error) => {});
  };

  const sorterFileName = (text) => {
    if (text.length >= 10) {
      return text.slice(0, 9) + "..." + text.slice(-4);
    } else {
      return text;
    }
  };

  const getMediaHandler = (e) => {
    e.preventDefault();
    const data = {
      order_key: dataDetail.order_key,
      system_name: process.env.REACT_APP_SYSTEM_NAME,
    };
    dispatch(getOrderMedia({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res && res.data.result === "success") {
          const fileData = res.data.value.file_data;
          const fileName = res.data.value.file_name;

          fetch("data:text/plain;charset=UTF-8;base64," + fileData)
            .then((response) => response.blob())
            .then((data) => {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(data);
              a.target = "_blank";
              a.download = fileName;
              a.click();
            });
          if (res.data && res.data.result === "success" && newToken) {
            dispatch(setToken(newToken));
          }
        }
      })
      .catch((error) => {
        if (error.error_message === "error get file data") {
          toast.error("エラーファイル取得");
        }
      });
  };

  // Change ATO DB linkage
  const [productName, setProductName] = useState(
    dataDetail?.extra?.sync?.product_name
  );
  const [isConfirmFederation, setIsConfirmFederation] = useState(false);
  const onSubmitFederationHandler = (event) => {
    event.preventDefault();
    setIsConfirmFederation(false);
    const dataSync = {
      order_key: orderId,
      product_name: productName,
    };

    dispatch(updateSyncData({ dataSync, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === "success") {
          getOrderDetailData();
          toast.success("データが更新された");
          if (res.data && res.data.result === "success" && newToken) {
            dispatch(setToken(newToken));
          }
        }
      })
      .catch((error) => {});
  };

  // Change Orikomi DB linkage
  const [productNameOrikomi, setProductNameOrikomi] = useState(
    dataDetail?.extra?.orikomi_product_name
  );
  const [isConfirmFederationOrikomi, setIsConfirmFederationOrikomi] =
    useState(false);
  const onSubmitFederationOrikomiHandler = (event) => {
    event.preventDefault();
    setIsConfirmFederation(false);
    const dataSync = {
      order_key: orderId,
      product_name: productNameOrikomi,
    };

    dispatch(updateSyncDataOrikomi({ dataSync, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        if (res.data && res.data.result === "success") {
          getOrderDetailData();
          toast.success("データが更新された");
          if (res.data && res.data.result === "success" && newToken) {
            dispatch(setToken(newToken));
          }
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getOrderMediaName();
  }, []);

  return (
    <>
      <div className="w-full w-12/12 flex flex-col sm:flex-row gap-0 sm:gap-2">
        {/* Left */}
        <div className="order__detail w-12/12 sm:w-6/12 flex flex-col">
          <table className="w-[100%] text-left text-sm md:text-base">
            <tbody className="">
              <tr>
                <td
                  colSpan="2"
                  className="bg-primary bg-opacity-50 font-semibold border-[1px] border-black px-2 py-[4px]"
                >
                  配布物情報・印刷データ
                </td>
              </tr>
              <tr>
                <td className="font-semibold">用紙サイズ</td>
                <td>{dataDetail?.paper_size}</td>
              </tr>
              <tr>
                <td className="font-semibold">用紙の厚さ</td>
                <td>{dataDetail?.thickness}</td>
              </tr>
              <tr>
                <td className="font-semibold">色</td>
                <td>{dataDetail?.color_type}</td>
              </tr>
              <tr>
                <td className="font-semibold">折込日</td>
                <td>{dataDetail?.insertion_date}</td>
              </tr>
              <tr>
                <td className="font-semibold">納品期限日</td>
                <td>{dataDetail?.delivery_date}</td>
              </tr>
              <tr className="">
                <td className="font-semibold ">入稿データ</td>
                <td className="">
                  <div className="flex justify-between">
                    {fileName !== "" ? sorterFileName(fileName) : "未入稿"}

                    <button
                      onClick={getMediaHandler}
                      disabled={fileName === ""}
                      className="px-4 py-[2px] flex justify-end items-center gap-2 disabled:bg-[#c4c4c4] bg-blue-700 text-white text-sm"
                    >
                      <FaDownload />
                      Download
                    </button>
                  </div>
                </td>
              </tr>
              <tr className="">
                <td className="font-semibold ">参照テキスト(チラシ名)</td>
                <td className="">
                  <div className="flex justify-between">
                    {dataDetail?.extra?.ref_text}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          {/* End Left */}

          {/* Ato backbone DB linkage */}
          <div className="w-12/12 w-full flex flex-col mt-8 sm:mt-4">
            <table className="w-full overflow-x-auto table-auto text-left text-sm md:text-base">
              <tbody className="">
                {/* Title */}
                <tr>
                  <td
                    colSpan="2"
                    className="bg-primary bg-opacity-50 text-black font-bold border-[1px] border-black px-2 py-[4px]"
                  >
                    アト基幹DB連携
                  </td>
                </tr>
                {/* End Title */}

                {/* Product name */}
                <tr>
                  <td className={tdStyleLocationLabel}>商品名</td>
                  <td className={tdStyleLocation}>
                    <div className="w-full flex justify-center items-center">
                      <input
                        className="w-full outline-none border border-black px-2"
                        type="text"
                        value={productName}
                        onChange={(event) => setProductName(event.target.value)}
                      />
                    </div>
                  </td>
                </tr>
                {/* End Product name */}

                {/* Update federation data */}
                <tr>
                  <td colSpan={2} className={tdStyleLocation}>
                    <div className="w-full flex justify-end items-center">
                      <button
                        onClick={() => setIsConfirmFederation(true)}
                        className="px-2 py-[2px] bg-blue-700 text-white rounded-[2px]"
                      >
                        連携データの更新
                      </button>
                    </div>
                  </td>
                </tr>
                {/* End Update federation data */}
              </tbody>
            </table>

            {/* Modal Confirm Federation */}
            <Modal
              isOpen={isConfirmFederation}
              onRequestClose={() => setIsConfirmFederation(false)}
              style={customStyles}
              contentLabel="Logout"
            >
              <button
                className="float-right rounded-full text-black text-xl"
                onClick={() => setIsConfirmFederation(false)}
              >
                <FaTimes />
              </button>
              <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
                連携データの更新 ?
              </h2>
              <form
                onSubmit={onSubmitFederationHandler}
                className="p-2 flex flex-col"
              >
                <div className="flex justify-end gap-2">
                  <button
                    className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                    type="submit"
                  >
                    確定する
                  </button>

                  <button
                    onClick={() => setIsConfirmFederation(false)}
                    className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                    type="button"
                  >
                    キャンセル
                  </button>
                </div>
              </form>
            </Modal>
            {/* Modal Confirm Federation */}
          </div>
          {/* End Ato backbone DB linkage */}

          {/* Orikomi backbone DB linkage */}
          <div className="w-12/12 w-full flex flex-col mt-8 sm:mt-4">
            <table className="w-full overflow-x-auto table-auto text-left text-sm md:text-base">
              <tbody className="">
                {/* Title */}
                <tr>
                  <td
                    colSpan="2"
                    className="bg-primary bg-opacity-50 text-black font-bold border-[1px] border-black px-2 py-[4px]"
                  >
                    おりこみ基幹DB連携
                  </td>
                </tr>
                {/* End Title */}

                {/* Product name */}
                <tr>
                  <td className={tdStyleLocationLabel}>商品名</td>
                  <td className={tdStyleLocation}>
                    <div className="w-full flex justify-center items-center">
                      <input
                        className="w-full outline-none border border-black px-2"
                        type="text"
                        value={productNameOrikomi}
                        onChange={(event) =>
                          setProductNameOrikomi(event.target.value)
                        }
                      />
                    </div>
                  </td>
                </tr>
                {/* End Product name */}

                {/* Update federation data */}
                <tr>
                  <td colSpan={2} className={tdStyleLocation}>
                    <div className="w-full flex justify-end items-center">
                      <button
                        onClick={() => setIsConfirmFederationOrikomi(true)}
                        className="px-2 py-[2px] bg-blue-700 text-white rounded-[2px]"
                      >
                        連携データの更新
                      </button>
                    </div>
                  </td>
                </tr>
                {/* End Update federation data */}
              </tbody>
            </table>

            {/* Modal Confirm Federation */}
            <Modal
              isOpen={isConfirmFederationOrikomi}
              onRequestClose={() => setIsConfirmFederationOrikomi(false)}
              style={customStyles}
              contentLabel="Logout"
            >
              <button
                className="float-right rounded-full text-black text-xl"
                onClick={() => setIsConfirmFederationOrikomi(false)}
              >
                <FaTimes />
              </button>
              <h2 className="text-left px-2 text-md sm:text-xl font-semibold mb-8">
                orikomi連携データの更新 ?
              </h2>
              <form
                onSubmit={onSubmitFederationOrikomiHandler}
                className="p-2 flex flex-col"
              >
                <div className="flex justify-end gap-2">
                  <button
                    className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                    type="submit"
                  >
                    確定する
                  </button>

                  <button
                    onClick={() => setIsConfirmFederationOrikomi(false)}
                    className=" bg-gray-900 text-white mt-4 p-2 rounded-sm font-semibold text-sm sm:text-md"
                    type="button"
                  >
                    キャンセル
                  </button>
                </div>
              </form>
            </Modal>
            {/* Modal Confirm Federation */}
          </div>
          {/* End Orikomi backbone DB linkage */}
        </div>

        {/* Right */}
        <div className="order__detail w-12/12 sm:w-6/12 mt-8 sm:mt-0">
          {/* Location */}
          <table className="w-[100%] text-left text-sm md:text-base">
            <tbody className="">
              <tr>
                <td
                  colSpan="2"
                  className="bg-primary bg-opacity-50 font-semibold border-[1px] border-black px-2 py-[4px]"
                >
                  折込エリア
                </td>
              </tr>
              <tr>
                <td className="font-semibold">折込エリア</td>
                <td>{`${dataDetail?.extra?.points[0]}  ${dataDetail?.extra?.points[1]}  ${dataDetail?.extra?.points[2]}`}</td>
              </tr>
              <tr>
                <td className="font-semibold">緯度</td>
                <td>{dataDetail?.center_loc?.lat}</td>
              </tr>
              <tr>
                <td className="font-semibold">経度</td>
                <td>{dataDetail?.center_loc?.lng}</td>
              </tr>
              <tr>
                <td className="font-semibold">半径</td>
                <td>{dataDetail?.radius}</td>
              </tr>
            </tbody>
          </table>
          {/* End Location */}

          {/* Brand Table */}
          <table className="brand__list__table w-[100%] text-left mt-8 sm:mt-4 text-sm md:text-base">
            <tbody>
              <tr>
                <td
                  colSpan="4"
                  className="bg-primary bg-opacity-50 font-semibold border-[1px] border-black px-2 py-[4px]"
                >
                  希望銘柄
                </td>
              </tr>
              <tr>
                <td className="w-2/12 font-semibold">新聞 CD</td>
                <td className="w-2/12 font-semibold">銘柄名</td>
                <td className="w-2/12 font-semibold">部数</td>
                <td className="w-3/12 font-semibold whitespace-nowrap">単価</td>
              </tr>
            </tbody>
            <tbody className="">
              {dataDetail?.estimation?.items.map((brand) => (
                <tr key={brand.brand}>
                  <td>{brand.brand_cd}</td>
                  <td>{brand.brand_name}</td>
                  <td>{brand.quantity}</td>
                  <td>{brand.each_unit_price?.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* End Brand Table */}
        </div>
        {/* End Right */}
      </div>
    </>
  );
};

const tdStyleLocationLabel =
  "w-[50%] border-[1px] border-black px-2 py-[4px] font-semibold";
const tdStyleLocation = "w-[50%] border-[1px] border-black px-2 py-[4px]";
const customStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    zIndex: 1000,
  },
  content: {
    maxHeight: "80vh",
    width: "80%",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    position: "relative",
    border: "1px solid black",
    background: "#fff",
  },
};

export default DistributionInformation;
